import { FC, TextareaHTMLAttributes } from "react";

import FieldError from "../FieldError";
import styles from "./styles.module.scss";

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
    className?: string;
    maxLength?: number;
    error?: string;
};

const TextArea: FC<Props> = ({ className, maxLength, error, ...rest }) => {
    let props = {};

    if (maxLength) {
        props = {
            maxLength,
        };
    }

    return (
        <div className={styles.root}>
            {maxLength && (
                <div className={styles.textarea_max_length}>
                    {(rest.value?.toString().length || 0)} / {maxLength}
                </div>
            )}
            <textarea
                {...rest}
                className={`${className ? className + " " : ""}${styles.textarea}${
                    error ? ` ${styles.textareaError}` : ""
                }`}
                aria-invalid={Boolean(error)}
                {...props}
            />
            <FieldError error={error} />
        </div>
    );
};

export default TextArea;
